function renderMotPages() {
  var dataScript = document.getElementById('magazine-data');
  if (!dataScript) {
    return false;
  }

  var magazineData;
  try {
    magazineData = JSON.parse(dataScript.textContent.trim());
  } catch (e) {
    return false;
  }

  if (!magazineData || !magazineData.mot) {
    return false;
  }

  var $motLeftPage = null;
  var $motRightPage = null;
  var $motLeftWrapper = $('.flipbook-wrapper .page-wrapper[page="4"]');
  var $motRightWrapper = $('.flipbook-wrapper .page-wrapper[page="5"]');
  
  if ($motLeftWrapper.length > 0 && $motRightWrapper.length > 0) {
    $motLeftPage = $motLeftWrapper.find('.mot-page.left-page');
    $motRightPage = $motRightWrapper.find('.mot-page.right-page');
  }
  
  if (!$motLeftPage || $motLeftPage.length === 0) {
    $motLeftPage = $('.flipbook-wrapper .mot-page.left-page');
    $motRightPage = $('.flipbook-wrapper .mot-page.right-page');
  }

  if ($motLeftPage.length === 0 || $motRightPage.length === 0) {
    return false;
  }

  if ($motRightPage.find('.mot-grid-container').length > 0) {
    return true;
  }

  var motLeftHtml = '<div class="mot-details">' +
    '<picture>' +
      '<source srcset="' + magazineData.mot.stickerWebP + '" type="image/webp">' +
      '<img src="' + magazineData.mot.sticker + '" alt="MOT logo" loading="lazy">' +
    '</picture>' +
    (magazineData.mot.description || '') +
  '</div>' +
  '<div class="page-number left-num">3</div>';

  var videos = magazineData.mot.videos || [];
  
  var videoItems = videos.map(function(mot) {
    return '<div class="mot-item" data-block-id="' + mot.id + '" data-video="' + mot.video + '">' +
      '<img class="mot-preview-image" src="' + mot.previewImage + '" loading="lazy" />' +
      '<video class="mot-video-thumbnail" playsinline preload="none">' +
        '<source src="' + mot.previewVideo + '" type="video/mp4">' +
        'Your browser does not support the video tag.' +
      '</video>' +
    '</div>';
  }).join('');

  var motRightHtml = '<div class="mot-grid-container">' +
    '<div class="mot-grid">' +
      videoItems +
    '</div>' +
  '</div>' +
  '<div class="page-number right-num">4</div>';

  $motLeftPage.html(motLeftHtml);
  $motRightPage.html(motRightHtml);

  setTimeout(function() {
    initMotInteractions();
  }, 100);
  
  return true;
}

function initMotInteractions() {
  var $videos = $('.mot-video-thumbnail');
  
  if ($videos.length === 0) {
    return;
  }
  
  let userInteracted = false;
  
  $(document).one('click touchstart', function () {
    userInteracted = true;
  });

  $(document).off('click.motItem').on('click.motItem', '.mot-item', function (e) {
    e.preventDefault();
    const videoUrl = $(this).data('video');

    $('.mot-video-thumbnail').each(function () {
      if (!this.paused) {
        this.pause();
      }
    });

    $('#modalVideo').attr('src', videoUrl);
    $('#motModal').fadeIn();
    
    var modalVideo = $('#modalVideo')[0];
    if (modalVideo) {
      modalVideo.play().catch(function(error) {
      });
    }
  });

  $(document).off('click.closeModal').on('click.closeModal', '.close-mot-modal', function () {
    $('#motModal').fadeOut();
    const modalVideo = $('#modalVideo')[0];
    if (modalVideo && !modalVideo.paused) {
      modalVideo.pause();
    }
    $('#modalVideo').attr('src', '');
  });

  $(document).off('click.modalOverlay').on('click.modalOverlay', '#motModal', function(e) {
    if ($(e.target).is('#motModal')) {
      $('.close-mot-modal').trigger('click');
    }
  });

  $(document).off('mouseenter.motPreview').on('mouseenter.motPreview', '.mot-item', function () {
    const $video = $(this).find('.mot-video-thumbnail')[0];
    const $image = $(this).find('.mot-preview-image');
    
    $image.css({ visibility: 'hidden', opacity: 0 });
    
    if (userInteracted && $video) { 
      $video.play().catch(function(error) {
      });
    }
  });

  $(document).off('mouseleave.motPreview').on('mouseleave.motPreview', '.mot-item', function () {
    const $video = $(this).find('.mot-video-thumbnail')[0];
    const $image = $(this).find('.mot-preview-image');
    
    if ($video) {
      $video.pause();
      $video.currentTime = 0; 
    }
    $image.css({ visibility: 'visible', opacity: 1 });
  });
}


function waitForTurnJs(callback, maxAttempts) {
  maxAttempts = maxAttempts || 20;
  var attempts = 0;
  
  var checkInterval = setInterval(function() {
    attempts++;
    var $flipbook = $('#flipbook');
    
    if ($flipbook.length && $flipbook.data('turn')) {
      clearInterval(checkInterval);
      callback();
    } else if (attempts >= maxAttempts) {
      clearInterval(checkInterval);
      callback();
    }
  }, 100);
}

$(document).ready(function () {

  initMotInteractions();
  
  $('#flipbook').on('turning', function(event, page, view) {
    if (page === 4 || page === 5 || view.indexOf(4) !== -1 || view.indexOf(5) !== -1) {
      setTimeout(function() {
        renderMotPages();
      }, 200);
    }
  });
  
  $('#flipbook').on('turned', function(event, page, view) {
    if (page === 4 || page === 5 || view.indexOf(4) !== -1 || view.indexOf(5) !== -1) {
      setTimeout(function() {
        renderMotPages();
      }, 200);
    }
  });
  

  waitForTurnJs(function() {
    var $flipbook = $('#flipbook');
    
    if ($flipbook.length && $flipbook.data('turn')) {
      var currentPage = $flipbook.turn('page');
      var view = $flipbook.turn('view');
      
      if (currentPage === 4 || currentPage === 5 || view.indexOf(4) !== -1 || view.indexOf(5) !== -1) {
        setTimeout(function() {
          renderMotPages();
        }, 300);
      }
    } else {
      setTimeout(function() {
        renderMotPages();
      }, 500);
    }
  });
});